import { PayloadAction } from "@reduxjs/toolkit";
import { delay, put, select, take, takeLatest } from "redux-saga/effects";

import { RegisteredDialog } from "../../dialog-registry";
import { getDialogStack } from "../../lib/selectors";
import dialogsSlice, { ActionConfirmationPayoad, closeDialog, openDialog, promptConfirmation } from "./dialogs.slice";

function* maybeCloseDialogsSaga(action: PayloadAction<RegisteredDialog[]>) {
  const dialogStack: ReturnType<typeof getDialogStack> = yield select(state => getDialogStack(state));

  for (let id of action.payload) {
    const matchIndex = dialogStack.findIndex(m => m.id === id);
    if (matchIndex > -1) {
      yield put(closeDialog(id));
    }
  }
}

export function* confirmationSaga(payload: ActionConfirmationPayoad) {
  yield put(promptConfirmation(payload));
  yield put(openDialog("CONFIRM_ACTION"));

  const nextAction = yield take([dialogsSlice.actions.confirm, dialogsSlice.actions.cancel]);

  if (nextAction.type === dialogsSlice.actions.confirm.type) {
    return true;
  }
  return false;
}

export function* closeConfirmationSaga() {
  yield put(closeDialog("CONFIRM_ACTION"));
  yield delay(400);
  yield put(dialogsSlice.actions.resetConfirmationModal());
}

function* closeDesignPortalSaga() {
  yield put(closeDialog("DESIGN_PORTAL"));
}

export function* dialogsSaga() {
  yield takeLatest(dialogsSlice.actions.maybeCloseDialogs, maybeCloseDialogsSaga);
  yield takeLatest(dialogsSlice.actions.closeDesignPortal, closeDesignPortalSaga);
}
